import React from 'react';
import { Link } from 'react-router-dom';

export default () => (
    <div id="statistics-dashboard">
        <header className="content-header">
            <h1>
                Statistics
                <small>dashboard</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-bar-chart"/> Statistics</li>
                <li className="text-bold"><Link to="/statistics">Dashboard</Link></li>
            </ol>
        </header>
        <section className="content">

        </section>
    </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Dashboard/index.js